import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'trabajoAgencias': [],
  'loading': false,
};

export const wtsTrabajoAgencias = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_TRABAJO_AGENCIAS]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TRABAJO_AGENCIAS]: (state, action) => ({
      ...state,
      'loading': false,
      'trabajoAgencias': action.response?.data || action.response || [],
    }),
    [ActionTypes.FETCHED_TRABAJO_AGENCIAS_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'trabajoAgencias': [],
    }),
    [ActionTypes.CREATING_TRABAJO_AGENCIA]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CREATED_TRABAJO_AGENCIA]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CREATED_TRABAJO_AGENCIA_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_TRABAJO_AGENCIA]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_TRABAJO_AGENCIA]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_TRABAJO_AGENCIA_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
